// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file internalapi/v1/banking_model.proto (package internalapi.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { ApprovalStatus } from "../../types/v1/status_pb";
import { file_types_v1_status } from "../../types/v1/status_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file internalapi/v1/banking_model.proto.
 */
export const file_internalapi_v1_banking_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_type_date, file_types_v1_status]);

/**
 * @generated from message internalapi.v1.Invoice
 */
export type Invoice = Message<"internalapi.v1.Invoice"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 display_id = 2;
   */
  displayId: number;

  /**
   * @generated from field: string organization_id = 3;
   */
  organizationId: string;

  /**
   * @generated from field: google.type.Date payment_date = 4;
   */
  paymentDate?: Date;

  /**
   * @generated from field: repeated string scheduled_bank_transaction_ids = 5;
   */
  scheduledBankTransactionIds: string[];

  /**
   * @generated from field: int64 bg_amount = 6;
   */
  bgAmount: bigint;

  /**
   * @generated from field: int64 jepx_amount = 7;
   */
  jepxAmount: bigint;

  /**
   * @generated from field: int64 eclear_fee_amount = 8;
   */
  eclearFeeAmount: bigint;

  /**
   * @generated from field: int64 deposit_amount = 9;
   */
  depositAmount: bigint;

  /**
   * @generated from field: uint64 total_without_tax = 11;
   */
  totalWithoutTax: bigint;

  /**
   * @generated from field: uint64 total_with_tax = 12;
   */
  totalWithTax: bigint;

  /**
   * @generated from field: uint64 balance_with_tax = 14;
   */
  balanceWithTax: bigint;

  /**
   * @generated from field: bool should_reconcile_from_deposit = 15;
   */
  shouldReconcileFromDeposit: boolean;

  /**
   * @generated from field: bool is_deposit_invoice = 16;
   */
  isDepositInvoice: boolean;

  /**
   * @generated from field: internalapi.v1.BankTransactionStatus status = 17;
   */
  status: BankTransactionStatus;

  /**
   * @generated from field: internalapi.v1.BankTransactionDebitCreditType debit_credit_type = 18;
   */
  debitCreditType: BankTransactionDebitCreditType;

  /**
   * @generated from field: int64 eclear_deposit_amount = 19;
   */
  eclearDepositAmount: bigint;

  /**
   * 付利額(非課税)
   *
   * @generated from field: int64 interest_amount = 20;
   */
  interestAmount: bigint;
};

/**
 * Describes the message internalapi.v1.Invoice.
 * Use `create(InvoiceSchema)` to create a new message.
 */
export const InvoiceSchema: GenMessage<Invoice> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_banking_model, 0);

/**
 * @generated from message internalapi.v1.ActualBankTransaction
 */
export type ActualBankTransaction = Message<"internalapi.v1.ActualBankTransaction"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.type.Date transaction_date = 2;
   */
  transactionDate?: Date;

  /**
   * @generated from field: internalapi.v1.BankTransactionDebitCreditType debit_credit_type = 3;
   */
  debitCreditType: BankTransactionDebitCreditType;

  /**
   * @generated from field: uint64 amount = 4;
   */
  amount: bigint;

  /**
   * @generated from field: uint64 balance = 5;
   */
  balance: bigint;

  /**
   * @generated from field: internalapi.v1.BankTransactionStatus status = 6;
   */
  status: BankTransactionStatus;

  /**
   * 依頼人名
   *
   * @generated from field: string applicant_name = 7;
   */
  applicantName: string;

  /**
   * 支払金融機関名カナ
   *
   * @generated from field: string payment_financial_institution_name_kana = 8;
   */
  paymentFinancialInstitutionNameKana: string;

  /**
   * 支店名カナ
   *
   * @generated from field: string branch_name_kana = 9;
   */
  branchNameKana: string;

  /**
   * 支払依頼人番号
   *
   * @generated from field: string payment_applicant_no = 10;
   */
  paymentApplicantNo: string;

  /**
   * EDI情報
   *
   * @generated from field: string edi_info = 11;
   */
  ediInfo: string;

  /**
   * 備考
   *
   * @generated from field: string remarks = 12;
   */
  remarks: string;

  /**
   * 取引種別
   *
   * @generated from field: string transaction_type = 13;
   */
  transactionType: string;
};

/**
 * Describes the message internalapi.v1.ActualBankTransaction.
 * Use `create(ActualBankTransactionSchema)` to create a new message.
 */
export const ActualBankTransactionSchema: GenMessage<ActualBankTransaction> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_banking_model, 1);

/**
 * @generated from message internalapi.v1.ScheduledBankTransaction
 */
export type ScheduledBankTransaction = Message<"internalapi.v1.ScheduledBankTransaction"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: optional string deal_id = 3;
   */
  dealId?: string;

  /**
   * @generated from field: google.type.Date scheduled_date = 4;
   */
  scheduledDate?: Date;

  /**
   * @generated from field: uint64 amount = 5;
   */
  amount: bigint;

  /**
   * @generated from field: uint64 balance = 7;
   */
  balance: bigint;

  /**
   * @generated from field: uint64 pending_balance = 8;
   */
  pendingBalance: bigint;

  /**
   * @generated from field: uint64 unapproved_balance = 9;
   */
  unapprovedBalance: bigint;

  /**
   * @generated from field: internalapi.v1.BankTransactionDebitCreditType debit_credit_type = 10;
   */
  debitCreditType: BankTransactionDebitCreditType;

  /**
   * @generated from field: internalapi.v1.BankTransactionUsageType usage = 11;
   */
  usage: BankTransactionUsageType;

  /**
   * @generated from field: internalapi.v1.BankTransactionStatus status = 12;
   */
  status: BankTransactionStatus;
};

/**
 * Describes the message internalapi.v1.ScheduledBankTransaction.
 * Use `create(ScheduledBankTransactionSchema)` to create a new message.
 */
export const ScheduledBankTransactionSchema: GenMessage<ScheduledBankTransaction> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_banking_model, 2);

/**
 * @generated from message internalapi.v1.ApprovalBankTransaction
 */
export type ApprovalBankTransaction = Message<"internalapi.v1.ApprovalBankTransaction"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 display_id = 2;
   */
  displayId: number;

  /**
   * @generated from field: types.v1.ApprovalStatus status = 3;
   */
  status: ApprovalStatus;

  /**
   * @generated from field: repeated internalapi.v1.ApprovalBankTransaction.JournalizedBankTransaction journalized_bank_transactions = 4;
   */
  journalizedBankTransactions: ApprovalBankTransaction_JournalizedBankTransaction[];
};

/**
 * Describes the message internalapi.v1.ApprovalBankTransaction.
 * Use `create(ApprovalBankTransactionSchema)` to create a new message.
 */
export const ApprovalBankTransactionSchema: GenMessage<ApprovalBankTransaction> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_banking_model, 3);

/**
 * @generated from message internalapi.v1.ApprovalBankTransaction.JournalizedBankTransaction
 */
export type ApprovalBankTransaction_JournalizedBankTransaction = Message<"internalapi.v1.ApprovalBankTransaction.JournalizedBankTransaction"> & {
  /**
   * @generated from field: optional string scheduled_bank_transaction_id = 1;
   */
  scheduledBankTransactionId?: string;

  /**
   * @generated from field: string actual_bank_transaction_id = 2;
   */
  actualBankTransactionId: string;

  /**
   * @generated from field: string organization_id = 3;
   */
  organizationId: string;

  /**
   * @generated from field: uint64 amount = 4;
   */
  amount: bigint;

  /**
   * @generated from field: internalapi.v1.BankTransactionDebitCreditType debit_credit_type = 5;
   */
  debitCreditType: BankTransactionDebitCreditType;

  /**
   * @generated from field: internalapi.v1.BankTransactionUsageType usage = 6;
   */
  usage: BankTransactionUsageType;
};

/**
 * Describes the message internalapi.v1.ApprovalBankTransaction.JournalizedBankTransaction.
 * Use `create(ApprovalBankTransaction_JournalizedBankTransactionSchema)` to create a new message.
 */
export const ApprovalBankTransaction_JournalizedBankTransactionSchema: GenMessage<ApprovalBankTransaction_JournalizedBankTransaction> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_banking_model, 3, 0);

/**
 * @generated from message internalapi.v1.VirtualBankAccountBalance
 */
export type VirtualBankAccountBalance = Message<"internalapi.v1.VirtualBankAccountBalance"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: int64 deposit = 4;
   */
  deposit: bigint;

  /**
   * @generated from field: int64 eclear_deposit = 6;
   */
  eclearDeposit: bigint;
};

/**
 * Describes the message internalapi.v1.VirtualBankAccountBalance.
 * Use `create(VirtualBankAccountBalanceSchema)` to create a new message.
 */
export const VirtualBankAccountBalanceSchema: GenMessage<VirtualBankAccountBalance> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_banking_model, 4);

/**
 * @generated from enum internalapi.v1.BankTransactionDebitCreditType
 */
export enum BankTransactionDebitCreditType {
  /**
   * @generated from enum value: BANK_TRANSACTION_DEBIT_CREDIT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 入金
   *
   * @generated from enum value: BANK_TRANSACTION_DEBIT_CREDIT_TYPE_DEBIT = 1;
   */
  DEBIT = 1,

  /**
   * 出金
   *
   * @generated from enum value: BANK_TRANSACTION_DEBIT_CREDIT_TYPE_CREDIT = 2;
   */
  CREDIT = 2,
}

/**
 * Describes the enum internalapi.v1.BankTransactionDebitCreditType.
 */
export const BankTransactionDebitCreditTypeSchema: GenEnum<BankTransactionDebitCreditType> = /*@__PURE__*/
  enumDesc(file_internalapi_v1_banking_model, 0);

/**
 * @generated from enum internalapi.v1.BankTransactionStatus
 */
export enum BankTransactionStatus {
  /**
   * @generated from enum value: BANK_TRANSACTION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 未参照
   *
   * @generated from enum value: BANK_TRANSACTION_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * 対応済
   *
   * @generated from enum value: BANK_TRANSACTION_STATUS_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * 一部対応
   *
   * @generated from enum value: BANK_TRANSACTION_STATUS_PARTIAL = 3;
   */
  PARTIAL = 3,

  /**
   * 預託金変動フラグ
   *
   * @generated from enum value: BANK_TRANSACTION_STATUS_DEPOSIT_UPDATE_MANUALLY = 4;
   */
  DEPOSIT_UPDATE_MANUALLY = 4,
}

/**
 * Describes the enum internalapi.v1.BankTransactionStatus.
 */
export const BankTransactionStatusSchema: GenEnum<BankTransactionStatus> = /*@__PURE__*/
  enumDesc(file_internalapi_v1_banking_model, 1);

/**
 * @generated from enum internalapi.v1.BankTransactionUsageType
 */
export enum BankTransactionUsageType {
  /**
   * @generated from enum value: BANK_TRANSACTION_USAGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * BG品代
   *
   * @generated from enum value: BANK_TRANSACTION_USAGE_TYPE_BG = 1;
   */
  BG = 1,

  /**
   * JEPX差金
   *
   * @generated from enum value: BANK_TRANSACTION_USAGE_TYPE_JEPX = 2;
   */
  JEPX = 2,

  /**
   * 預託金
   *
   * @generated from enum value: BANK_TRANSACTION_USAGE_TYPE_DEPOSIT = 3;
   */
  DEPOSIT = 3,

  /**
   * eClear手数料
   *
   * @generated from enum value: BANK_TRANSACTION_USAGE_TYPE_ECLEAR_FEE = 4;
   */
  ECLEAR_FEE = 4,

  /**
   * 振込手数料(預託金)
   *
   * @generated from enum value: BANK_TRANSACTION_USAGE_TYPE_DEPOSIT_TRANSFER_FEE = 5;
   */
  DEPOSIT_TRANSFER_FEE = 5,

  /**
   * eClear預託金
   *
   * @generated from enum value: BANK_TRANSACTION_USAGE_TYPE_ECLEAR_DEPOSIT = 6;
   */
  ECLEAR_DEPOSIT = 6,

  /**
   * 消費税(請求単位・仕訳専用)
   *
   * @generated from enum value: BANK_TRANSACTION_USAGE_TYPE_TAX = 7;
   */
  TAX = 7,

  /**
   * マージンコール
   *
   * @generated from enum value: BANK_TRANSACTION_USAGE_TYPE_MARGIN_CALL = 8;
   */
  MARGIN_CALL = 8,

  /**
   * 付利
   *
   * @generated from enum value: BANK_TRANSACTION_USAGE_TYPE_INTEREST = 9;
   */
  INTEREST = 9,
}

/**
 * Describes the enum internalapi.v1.BankTransactionUsageType.
 */
export const BankTransactionUsageTypeSchema: GenEnum<BankTransactionUsageType> = /*@__PURE__*/
  enumDesc(file_internalapi_v1_banking_model, 2);

